module.exports = __webpack_public_path__ + "static/media/dataspace.137412ec.jpg";